const custom = {
  gameoo: {
    searchPlaceholder: "Recherche ...",
    consumeVoucher: "Enregistrer récompense ...",
    newVoucher: "Nouvelle récompense ...",
    locationSelectPlaceholder:
      "Veuillez sélectionner une ville pour choisir un emplacement",
    entityTypeSelectPlaceholder: "Sélectionnez un type d'entité",
    homePage: "Accueil",
    gameTitle: "Jeux",
    gameSearch: "Recherche un jeux",
    signIn: {
      formTitle: "Connexion à GAMEOO",
      noAccount: "Vous n'avez pas encore un compte,",
      btnConnect: "Se connecter",
      lnkForgotPassword: "Mot de passe oublié ?",
      forgotPassword: {
        title: "Mot de passe oublié",
        instruction: "Saisissez l’adresse e-mail associée à votre compte.",
        emailLabel: "Adresse e-mail",
        sendButtonLabel: "Envoyer le lien de réinitialisation",
        successMessage:
          "Si un compte correspond à cette adresse, vous recevrez un lien permettant de réinitialiser votre mot de passe.",
        errorMessage:
          "Une erreur est survenue. Veuillez réessayer dans quelques instants.",
        backToLogin: "Retour à la page de connexion",
        submitting: "Envoi en cours ...",
        authProviderUnavailable:
          "Le service d’authentification n’est pas disponible.",
      },
    },
    register: {
      title: "Créer un compte GAMEOO",
      pseudoLabel: "Pseudo",
      fullNameLabel: "Nom complet",
      emailLabel: "Adresse e-mail",
      passwordLabel: "Mot de passe",
      confirmPasswordLabel: "Confirmer le mot de passe",
      submitButtonLabel: "Créer mon compte",
      alreadyHaveAccount: "Déjà un compte ?",
      signInLinkLabel: "Se connecter",
      creatingAccount: "Création du compte en cours ...",
      errorMessage:
        "Une erreur est survenue lors de la création du compte. Veuillez réessayer dans quelques instants.",
      genderLabel: "Genre",
      regionLabel: "Région",
      localityLabel: "Localité",
      birthYearLabel: "Année de naissance",
      gender: {
        H: "Homme",
        F: "Femme",
        JE_NE_VEUX_PAS: "Je ne souhaite pas préciser",
      },
      regions: {
        ANTANANARIVO: "Antananarivo",
        ANTSIRANANA: "Antsiranana",
        FIANARANTSOA: "Fianarantsoa",
        MAHAJANGA: "Mahajanga",
        TOAMASINA: "Toamasina",
        TOLIARA: "Toliara",
      },
    },
    passwordField: {
      showPassword: "Afficher le mot de passe",
      hidePassword: "Masquer le mot de passe",
    },
    signUpLabel: "S'inscrire",
    claimVoucherButtonLabel: "Réclamer un voucher",
    claimVoucherTitle: "Enregistrer une récompense",
    claimSuccess: "Code envoyé avec succès ✅ : %{pseudo} et %{code}",
    claimCancel: "Annuler",
    claimValidate: "Valider",
    claimVoucherInstruction:
      "Voulez vous récalamer le produit : %{productName} chez %{entityName} ?",
    chooseLocation: {
      title: "Choisir un emplacement",
      entityLabel: "Choisir l'entité",
      cityLabel: "Choisir la ville",
      locationLabel: "Choisir l'emplacement",
      cancel: "Annuler",
      save: "Commence le jeu",
    },
    play: "Jouer",
    dashboard: {
      youGot: "Tu as :",
      points: "COINS",
      gamesPlayed: "Jeux joués",
      vouchersClaimed: "Vouchers réclamés",
      playCount: "Parties jouées",
      playground: "Air de jeux",
      lastPlayLabel: "Dernière partie",
      activitySummary: "Synthèse des activités",
      recentGames: "Jeux récents",
      noRecentGames: "Aucun jeu récent",
      viewAll: "Voir tout",
      trophy: "Trophée",
      welcomeBack: "Salut %{pseudo}!",
      youHaveAmountMGA: "Tu as : %{{amount} coins",
      partOfPlayers:
        "Tu fais partie des %{percentage}% de joueurs qui ont un montant plus de %{threshold}.",
      thresholdUp: "Au-dessus du seuil",
      thresholdDown: "En-dessous du seuil",
      entityPlayLabel: "Entités visités",
      voucherClaimed: "Réclamés",
      voucherConsumed: "Consumés",
      consumedToClaimedRatio: "Ratio consumés/réclamés",
      consumedToClaimedPct: "Pourcentage consumés/réclamés",
      voucherClaimedStatement:
        "Sur %{claimed} bons réclamés, tu en as consommé %{consumed}, soit %{pct} % (ratio %{ratio}).",
      voucherClaimedTitle: "Utilisation des vouchers",
      voucherConsumedTitle: "Vouchers consommés",
    },
    historyVoucher: {
      voucherClaimedLabel: "réclamé",
      voucherConsumedLabel: "consommé",
      voucherTypeBogoLabel: "BOGO",
      voucherTypeDiscountLabel: "Réduction",
      voucherTypeGiftCardLabel: "Carte cadeau",
      voucherTypeFreeProductLabel: "Produit offert",
    },
  },
};

export default custom;
